import {QUERY_KEYS, queryClient} from '@/queryClient.ts'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types/commons.ts'
import {errorHandler} from '@utilities/genericErrorHandler.ts'
import {httpDeleteTicket} from '@/features/tickets/services/tickets.http.ts'
import {raise} from '@utilities/helpers.ts'

export const useDeleteTicket = (ticketId?: number, options?: Omit<UseMutationOptions, 'mutationFn'>) => {
    return useMutation({
        ...options,
        mutationFn: () => httpDeleteTicket({ticketId: ticketId || raise('ticketId id undefined')}),
        onError: (error: AxiosError<ErrorResponseData>) => {
            errorHandler(error)
        },
        onSuccess: (data, variables, context) => {
            options?.onSuccess?.(data, variables, context)
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.TICKETS]})
        }
    })
}
